define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/heading/AttributeAction",
	"csi/heading/Time",
	"csi/xml",
	"./_CompletionRendererMixin"
], function(array,declare,lang,csi,AttributeAction,Time,xml,_CompletionRendererMixin) {

	var	_Action = declare(AttributeAction, {
		m_id: "ActionTime",

		checkNodeAccess: function(/*Node*/node) {
			return xml.nodeHasAccess(node, this.m_right) && xml.nodeHasRight(node, this.m_rightBase);
		}
	});

	return declare([Time, _CompletionRendererMixin], {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported
			return null;
		},

		_reserveContext: function(/*Context*/ctx,/*Node*/cal, /*Node*/actMaster, /*Boolean*/bNewContext) {
			// summary: apply any renderer-specific changes to context before use
			var	cache = ctx.cache;

			if (!actMaster && ctx.keyValue!=null && ctx.keyValue>=0) {
				actMaster = this._getMasterActivity(ctx, cal);
			}

			var	actProto = this._getProtoActivity(ctx, actMaster);
			var calendarContainer = cache.getNode(cal.__Parent__);
			if (!calendarContainer)
				return;

			var levelAct = actProto.ActivityLevel;
			var levelItem = cache.getNode(calendarContainer.CalendarLevel);

			// keep track if activity at same level as calendar parent
			ctx.__bLevel = (levelAct == levelItem.$URL);
			ctx.__activity = null;

			// remarks are always on the Same Level as row.
			ctx.__remarks = ctx.cache.getNode(cal.CalendarRollup);

			// make sure to use calendar at level of activity or above since expressions do not roll down
			if (!ctx.__bLevel) {
				var levelChildren = levelItem.AllChildren;
				while (levelAct != levelItem.$URL && levelChildren && array.indexOf(levelChildren,levelAct) == -1) {
					cal = cache.getNode(cal.Parent);
					levelItem = cache.getNode(cache.getNode(cal.__Parent__).CalendarLevel);
					levelChildren = levelItem.AllChildren;
					bNewContext = true;
				}
			} else {
				var actMasterURL = actMaster.$URL;
				var activities = cache.getNodes(cal.Activities) || [];
				var milestones = cache.getNodes(cal.Milestones) || [];
				activities = activities.concat(milestones);

				var theActivity = null;
				array.some(activities, function (activity) {
					if (activity.Master != actMasterURL)
						return false;
					theActivity =  activity;
					return true;
				}, this);
				if (theActivity) {
					ctx.__activity = theActivity;
				}
			}

			ctx.__calendar = cal;
			ctx.__rollup = ctx.cache.getNode(cal.CalendarRollup);
			ctx.__reserveMarker = true;
			ctx.keyValue = actMaster.Index;

			if (bNewContext) {
				ctx.pushParams().setNode(ctx.__rollup);
				ctx.setReadOnly(false);
				ctx.__popContext = true;
			}
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			if (ctx.__popContext) {
				ctx.__popContext = false;
				ctx.pop();
			}

			if (!ctx.__releaseMarker) {
				this.inherited(arguments);
			}

			ctx.__reserveMarker = false;
		},

		reserveContextIfNeeded: function(/*Context*/ctx, /*Heading*/h) {
			// summary: make sure context has references to all necessary data
			if (!ctx.__reserveMarker) {
				this.reserveContext(ctx, h);
				ctx.__releaseMarker = true;
			}
		},

		releaseContextIfNeeded: function(/*Context*/ctx, /*Heading*/h) {
			// summary: only release context
			if (ctx.__releaseMarker) {
				this.releaseContext(ctx, h);
				ctx.__releaseMarker = false;
			}
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if completion date is empty, then look to completeness
			return this.inherited(arguments) || this._getCalendarValue(ctx, ctx.getNode(), "Completeness");
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			this.reserveContextIfNeeded(ctx, h);
			var css = this._addCompletionCSS(ctx, this.inherited(arguments));
			this.releaseContextIfNeeded(ctx, h);
			return css;
		},

		_getAction: function() {
			// summary: use time controller for editing
			return lang.mixin(new _Action(), {
				m_onAction: lang.hitch(this, this._onActionDate)
			});
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: even though CalendarRollup.CompletionDate has expression, they are really editing the
			// Activity.CompletionDate that has no expression; so, revert the CSS indicating an expression
			if (this._onAccessAction(ctx)) {
				var	ad = this.inherited(arguments);
				if (ad) {
					ad.cssEdit = null;
				}

				return ad;
			}

			return null;
		},

		_onAccessAction: function(/*Context*/ctx, /*Action*/action) {
			// summary: determine if activity is editable at current level
			if (ctx.__bLevel !== false) {
				var	actProto = this._getProtoActivity(ctx);
				return actProto.ActivityType == "ACTIVITYTYPE:Activity";
			}

			return false;
		},

		_onActionDate: function(/*Controller*/ac) {
			// summary: update calendar timevector attribute as well
			var	rollup = ac.getNode();
			var	cache = ac.m_cache;
			var	index = ac.keyContainer;
			var cal = cache.getNode(rollup.__Parent__);
			var	act = csi.search(cache.getNodes(cal.Activities), function(a) {
				return cache.getNode(a.Master).Index == index;
			});

			ac.m_writer.changeNode(act.$URL).changeAttribute(ac.heading.m_id, xml.ATTR_TIME, ac.newValue);
		}
	});
});